import { Filter as FilterModel } from '../../../filters/shared';

export class Filter {
  _id?: string;
  filter: FilterModel;
  value: string;
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/filter.model.ts